<template>
  <div>
    <el-form :model="deviceInventoryForm" ref="deviceInventoryFormRef" label-width="100px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item
            prop="code"
            label="盘点单号"
            :rules="[{ required: true, message: '盘点单号不能为空！', trigger: 'blur' }]"
          >
            <el-input v-model="deviceInventoryForm.code" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="项目名称"
            prop="projectId"
            :rules="[{ required: true, message: '项目名称不能为空！', trigger: 'blur' }]"
          >
            <el-select disabled v-model="deviceInventoryForm.projectId" placeholder="项目名称">
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            label="任务名称"
            prop="name"
            :rules="[{ required: true, message: '任务名称不能为空！', trigger: 'blur' }]"
          >
            <el-input
              :disabled="operateStatus == 3"
              maxlength="30"
              show-word-limit
              v-model="deviceInventoryForm.name"
              clearable
              placeholder="请输入 任务名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item
            label="盘点人"
            prop="checkUserIds"
            :rules="[{ required: true, message: '请选择盘点成员！', trigger: 'change' }]"
          >
            <choicePeople v-if="operateStatus!=3" :option="choicePeopleOption" @getPeople="getPeople" />
            <el-input v-else :disabled="true" v-model="checkPcUserNames" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="盘点时间"
            prop="checkTime"
            :rules="[{ required: true, message: '请选择盘点时间！', trigger: 'blur' }]"
          >
            <el-date-picker
              :disabled="operateStatus == 3"
              v-model="deviceInventoryForm.checkTime"
              type="daterange"
              value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input
              clearable
              placeholder="请输入 备注信息"
              :disabled="operateStatus == 3"
              v-model="deviceInventoryForm.description"
              maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <consumable-selector
      :operateStatus="operateStatus"
      :projectId="projectId"
      :submitTable="submitDeviceList"
      @returnChoiceDevice="returnChoiceDevice"
    ></consumable-selector>
    <div class="btnArea">
      <el-button
        size="small"
        icon="el-icon-circle-plus-outline"
        type="primary"
        v-show="operateStatus != 3"
        @click="handleSubmitDeviceInventoryForm"
        >{{ this.title === '编辑' ? '修 改' : '保 存' }}</el-button
      >
      <el-button
        size="small"
        icon="el-icon-circle-close"
        v-show="operateStatus != 3"
        @click="handleDeviceInventoryFormClose"
        >取消</el-button
      >
    </div>
    <el-dialog
      title="请选择人员"
      :visible.sync="dialogUserEditBoxVisible"
      fullscreen
      append-to-body
      width="80%"
    >
      <user-edit-box
        v-if="dialogUserEditBoxVisible"
        :remainUserListInside.sync="remainUserList"
        :userNum="20"
        @closeAction="handleCloseAction"
        @submitAction="handleSubmitAction"
        @editAction="handleEditAction"
        :selectType.sync="selectUserType"
        :handleAction.sync="handleAction"
        :projectId.sync="projectId"
      />
    </el-dialog>
  </div>
</template>

<script>
import ConsumableSelector from './consumable-selector';
import dayjs from 'dayjs';
import userEditBox from '@/components/user-edit-box/user-edit-box';
import { submitInventory, submitEditInventory } from '@/api/crmedical/device/deviceInventory';
import choicePeople from '@/components/choicePeopleOrDept/choicePeopleInput.vue';

export default {
  components: { ConsumableSelector, userEditBox, choicePeople },
  props: {
    title: '',
    code: '',
    projectId: '',
    projectList: [],
    inventoryPeople:[],
    //页面操作状态 1 新增 2 编辑 3 查看
    operateStatus: '',
  },
  data() {
    return {
      choicePeopleOption: {
        projectId: '',
        variable: '',
        searchType: '',
        deptId: '',
        model: 'people', //singlePeople(单选人员)，people(选人 有限制加limit) unlimitPeople(无限制选人) dept(部门 有限制加上limit) singleDept unlimitDept(无限制选部门)
        selectList: [], //已选的集合
        prohibitList: [], //禁止选的集合
        limit: 20,
      },
      //基础信息
      deviceInventoryForm: {
        code: '', //盘点单号
        projectId: '', //项目id
        name: '', //项目名称
        checkTime: [], //盘点时间
        checkStartTime: '',
        checkEndTime: '',
        checkUserIds: '', //盘点人员id
        description: '', //备注
      },
      submitDeviceList: [], //设备list
      dialogUserEditBoxVisible: false,
      checkPcUserNames: '', //盘点人员姓名
      remainUserList: [],
      selectUserType: '1',
      handleAction: '', //1是新增模式,2是编辑模式。
    };
  },
  created() {
    this.choicePeopleOption.projectId = this.projectId;

    this.initData();
  },
  mounted() {
    console.log(this.title);
    console.log("inventoryPeople",this.inventoryPeople)
    this.inventoryPeople.forEach(item=>{
       this.choicePeopleOption.selectList.push(item)
    })

    // this.$nextTick(()=>{
    //    console.log('cccc',this.choicePeopleOption.selectList)
    //   this.$forceUpdate()
    // })
  },
  methods: {
    //选人组件获取人员后赋值
    getPeople(obj) {
      console.log(obj);
      let idArray = [];
      obj.forEach((ele) => {
        idArray.push(ele.id);
      });
      let idStr = idArray.join(',')
      this.deviceInventoryForm.checkUserIds=idStr
      // form为表单名字并ref="form"; prop 换成你想监听的prop字段
       this.$refs['deviceInventoryFormRef'].validateField('checkUserIds', (errMsg) => {
                    if (errMsg) {
                        console.log('校验失败')
                    }else{
                        //...
                    }
                })

    },
    handleCloseAction() {
      this.dialogUserEditBoxVisible = false;
    },
    //关闭对话框
    handleDeviceInventoryFormClose() {
      this.$emit('closeDialog');
    },
    handleSubmitDeviceInventoryForm() {
      //提交信息
      this.$refs['deviceInventoryFormRef'].validate((valid) => {
        if (valid) {
          if (this.submitDeviceList.length > 0) {
            this.deviceInventoryForm.checkStartTime = this.deviceInventoryForm.checkTime[0];
            this.deviceInventoryForm.checkEndTime = this.deviceInventoryForm.checkTime[1];
            this.deviceInventoryForm.checkTime = '';
            this.deviceInventoryForm.totalQuantity = this.submitDeviceList.length;
            let obj = Object.assign({ device: this.submitDeviceList }, this.deviceInventoryForm);
            console.log('操作类型', this.operateStatus);
            if (this.operateStatus == '1') {
              submitInventory(obj).then((result) => {
                if (result.code == 200) {
                  this.$message({
                    message: '提交成功',
                    type: 'success',
                  });
                  this.handleDeviceInventoryFormClose();
                }
              });
            } else {
              submitEditInventory(obj).then((result) => {
                if (result.code == 200) {
                  this.$message({
                    message: '提交成功',
                    type: 'success',
                  });
                  this.handleDeviceInventoryFormClose();
                }
              });
            }
          } else {
            this.$message({
              message: '设备不能为空',
              type: 'error',
            });
            return;
          }
        } else {
          return;
        }
      });
    },
    initData() {
      this.deviceInventoryForm.code = this.code;
      this.deviceInventoryForm.projectId = this.projectId;
      if (this.operateStatus == 1) {
        let nowDay = dayjs().format('YYYY-MM-DD HH:mm:ss');
        this.deviceInventoryForm.checkTime = [nowDay, nowDay];
      }
    },
    handleAddGroup() {
      this.handleAction = this.operateStatus;
      // console.log(this.handleAction)
      this.dialogUserEditBoxVisible = true;
    },
    handleSubmitAction(val) {
      this.checkPcUserNames = val.nameListString;
      this.deviceInventoryForm.checkUserIds = val.idListString;
      this.dialogUserEditBoxVisible = false;
    },
    handleEditAction(val) {
      this.checkPcUserNames = val.nameListString;
      this.deviceInventoryForm.checkUserIds = val.idListString;
      this.dialogUserEditBoxVisible = false;
    },
    returnChoiceDevice(val) {
      this.submitDeviceList = val;
    },
  },
};
</script>

<style scoped>
.btnArea {
  widows: 100%;
  text-align: right;
  margin-top: 20px;
}
</style>
